import React from 'react'
import { withRouteData } from 'react-static'

import { trackedClick, getMarkedCookieValue } from 'utils'

import docsSvg from '../assets/docs.svg'

const DocLink = ({ docs }) => {
    if (!docs) {
        return null
    }
    const { label, url } = docs

    return (
        <li className="hub-card__links-item">
            <a
                className="hub-card__links-link"
                href={url}
                title={label}
                onClick={trackedClick('Dev resources link clicked', {
                    source: 'Intent page',
                    title: label,
                })}
                target="_blank"
                rel="noopener noreferrer"
            >
                {label}
            </a>
        </li>
    )
}

class CheckOut extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            url: global.INTENTO_CONSOLE_URL || process.env.INTENTO_CONSOLE_URL,
            next: window.location,
            consoleUser: getMarkedCookieValue('CU'),
        }
    }

    render() {
        const { url, next, consoleUser } = this.state
        const { intent } = this.props
        const title = consoleUser ? 'Go to console' : 'Get started'
        const href = consoleUser ? url : `${url}/register?next=${next}#mt-demo`

        return (
            <div className="hub-card__innerinner__main">
                <h3 className="hub-card__title">
                    Check out developers documentation
                </h3>
                <p className="hub-card__text">
                    You can find all developers documetation and find out how to
                    integrate
                </p>
                <ul className="hub-card__links">
                    <DocLink
                        docs={{
                            label: 'Intento API docs',
                            url: 'https://github.com/intento/intento-api',
                        }}
                    />
                    <DocLink docs={intent.docs} />
                    <DocLink
                        docs={{
                            label: 'Interactive docs',
                            url: 'https://intento.github.io',
                        }}
                    />
                </ul>
                <div className="hub-card__cta">
                    <a
                        className="button button--lg button--blue button--outline"
                        href={href}
                        title={title}
                        onClick={trackedClick('API Links link clicked', {
                            source: 'API page',
                            title,
                        })}
                    >
                        {title}
                    </a>
                </div>
            </div>
        )
    }
}

const DevResources = ({ intent }) => (
    <section id="mt-resources" className="section resources-section">
        <div className="section__container container">
            <header className="section__header">
                <h2 className="section__title">Developer Resources</h2>
            </header>
            <div className="section__content">
                <div className="hub-cards">
                    <div className="hub-cards__list">
                        <div className="hub-cards__item hub-cards__item--full">
                            <div className="hub-card hub-card--horiz">
                                <div className="hub-card__inner">
                                    <div className="hub-card__innerinner">
                                        <div className="hub-card__image">
                                            <img
                                                width="106"
                                                height="101"
                                                src={docsSvg}
                                                alt=""
                                            />
                                        </div>
                                        <CheckOut intent={intent} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
)

export default withRouteData(DevResources)



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/DevResources.jsx